var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(!_vm.deletingItem)?_c('i',{staticClass:"fa fa-trash text-danger",on:{"click":_vm.handleDeleteConfirmation}}):_vm._e(),(_vm.deletingItem)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }